import React from 'react';
import { Layout } from 'antd';
import { Link } from 'react-router-dom';
import './IconFooter.scss';
import {
  termsOfUseRoute,
  privacyPolicyRoute,
  supportRoute,
  section508Route,
} from '../../config/navigation/routes';

const Footer = Layout.Footer;

function IconFooter() {
  return (
    <Footer className="nffs-icon-footer">
      <span className="nffs-icon-footer-links-container">
        <span className="nffs-icon-footer-links">
          <div>
            <a href="/about">About ICON</a>
          </div>
          <div>
            <a href="/contact">Contact Us</a>
          </div>
          <div>
            <Link to={supportRoute || '/support'}>Support</Link>
          </div>
          <div>
            <Link to={termsOfUseRoute}>Terms of Use</Link>
          </div>
          <div>
            <Link to={privacyPolicyRoute || '/privacy-policy'}>
              Privacy Policy
            </Link>
          </div>
          <div>
            <Link to={section508Route || '/section-508'}>Section 508</Link>
          </div>
        </span>
      </span>

      <span>
        Use of the ICON portal requires{' '}
        <a
          href="https://www.google.com/chrome/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Google Chrome
        </a>,{' '}
        <a
          href="https://www.mozilla.org/en-US/firefox/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Mozilla Firefox
        </a>{' '}
        or{' '}
        <a
          href="https://www.microsoft.com/en-us/windows/microsoft-edge"
          target="_blank"
          rel="noopener noreferrer"
        >
          Microsoft Edge
        </a>{' '}
        with cookies and Javascript enabled.
      </span>
    </Footer>
  );
}

export default IconFooter;



// WEBPACK FOOTER //
// ./src/components/IconFooter/IconFooter.jsx